import { AiClient, SubjectLineGenerationPayload } from 'api/clients/AiClient'
import { pipe } from 'lodash/fp'
import {
  removeBulletListPrefixes,
  removeNumberedListPrefixes,
  removeSurroundingQuotes,
  trim,
} from 'components/Wizards/sanitisers'

export const generateSubjectLines = async ({
  payload,
  signal,
}: {
  payload: SubjectLineGenerationPayload
  signal?: AbortSignal
}) => {
  const subjectLinesResponse = await AiClient.generateSubjectLines({ payload, signal })

  return subjectLinesResponse.split(/\n/).map(sanitise).filter(Boolean).slice(0, 5)
}

const sanitise = (str: string) =>
  pipe(trim, removeNumberedListPrefixes, removeBulletListPrefixes, removeSurroundingQuotes)(str)
